// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"25c9b75c","838":"71cc2f04"}[chunkId] + ".js";
};